var _path, _path2, _path3, _path4;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgParceDetailBlue(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 31,
    height: 31,
    viewBox: "0 0 31 31",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.683 25.0541L6 19.5717V8.0166L15.683 13.4147V25.0541Z",
    fill: "#C9EFFE"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M16.4072 25.0541L26.0002 19.5717V8.0166L16.4072 13.4147V25.0541Z",
    fill: "#C9EFFE"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M21.4647 9.91413L25.9996 7.41181L16 2L11.6768 4.33969L21.4647 9.91413Z",
    fill: "#C9EFFE"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M11.2316 4.58032L6 7.41179L15.9997 12.9294L21.0237 10.1574L11.2316 4.58032Z",
    fill: "#C9EFFE"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgParceDetailBlue);
export default __webpack_public_path__ + "static/media/parce-detail-blue.5b40fab443bc8357b52223efd19cdfa7.svg";
export { ForwardRef as ReactComponent };